import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine'
import { InitCameraRatio, updateCamera, updateComparativeCamera } from 'Domain/Scene/Handler/CameraHandler'
import { rendererFormat } from 'Domain/Scene/Handler/RenderHandler'
import { getViewports, getViewportMode, getIsPortrait } from 'Domain/Scene/Handler/ViewportHandler'
import { computeViewportBoxes } from 'Domain/Scene/Handler/viewportLayout'
import { GridUpdate } from '../../Mesh/Handler/Grid'
import { bigScale, defaultScale } from '../Builder/LabelBuilder'
import { composerRender } from 'Domain/Mesh/Handler/Composer'
import { updateAnimationState } from './AnimationManager'
import { updateOrbitControlCamera } from './ControlSyncManager'

export const adjustStrippingScaleForViewport = () => {
  const isMultiViewport = getViewportMode() !== 'single'

  const tempGroup = threeEngine.getTempGroup()
  if (!tempGroup) return
  tempGroup.children.forEach(obj => {
    if (obj.type === 'Line') return
    isMultiViewport ? bigScale(obj) : defaultScale(obj)
  })
}

export const adjustMarkupScaleForViewport = () => {
  const viewportMode = getViewportMode()
  const marks = threeEngine.getMarks()
  if (!marks) return

  let factor = 1
  if (viewportMode === 'double') factor = 1.5
  else if (viewportMode === 'triple') factor = 2

  marks.traverse(obj => {
    if (obj.type === 'Line') return
    if (!obj.userData?.baseScale || !obj.scale) return
    obj.scale.set(obj.userData.baseScale * factor, obj.userData.baseScale * factor, obj.userData.baseScale * factor)
  })
}

const setupCamera = (viewportName, viewportWidth, viewportHeight, isPortrait) => {
  const camera = threeEngine.getCamera(viewportName)
  if (!camera) return null
  updateCamera(camera, threeEngine.getControls(), threeEngine.getCenter())
  InitCameraRatio(viewportWidth, viewportHeight, camera, isPortrait)
  return camera
}

const renderViewport = (scene, renderer, camera, viewportWidth, viewportHeight) => {
  renderer.clear()
  GridUpdate(scene, camera)
  updateComparativeCamera()
  composerRender(scene, camera, viewportWidth, viewportHeight)
}

export const renderAllViewports = (scene, renderer, canvasWidth, canvasHeight) => {
  const viewports = getViewports()
  const isPortrait = getIsPortrait()
  const boxes = computeViewportBoxes(canvasWidth, canvasHeight, viewports.length, isPortrait)

  viewports.forEach((viewport, index) => {
    const box = boxes[index]
    rendererFormat(renderer, box.x, box.y, box.width, box.height)
    const camera = setupCamera(viewport.name, box.width, box.height, isPortrait)
    if (!camera) return
    updateAnimationState(camera)
    renderViewport(scene, renderer, camera, box.width, box.height)
  })

  updateOrbitControlCamera()
}
